import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CourseImageWrapper from './CourseImageWrapper';
import CourseCardWrapper from './CourseCardWrapper';
import CourseInfoWrapper from './CourseInfoWrapper';
import Flex from '../Flex';
import Figure from '../Figure';
import Ribbon from '../Ribbon';
import { LoadingSpinner } from '../molecules/Button/LoadingElements';
import SimpleButton from '../molecules/Button/SimpleButton';
import { getUserThemeColor, themeGradientBg } from '../theme/colors';
import ImagePlaceholder from './ImagePlaceholder';

const UpdatingSpinnerContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
`;

const DashboardCourseCard = ({ courseInfo, goToCoursePage, goToEditCourse, inGrid, draftCourses, isUpdating }) => {
  const { t } = useTranslation();

  const { coverImage, coverUrl } = courseInfo;
  const imageUrl = !coverImage ? coverUrl : Array.isArray(coverImage) ? coverImage[0].url : coverImage?.url;
  const themeColor = getUserThemeColor(courseInfo.ownerColor);
  const clickOnCard = () => {
    goToCoursePage(courseInfo, courseInfo.type === 2);
  };

  const clickForEditCourse = (e) => {
    e.preventDefault();
    e.stopPropagation();
    goToEditCourse(courseInfo, courseInfo.type === 2);
  };

  return (
    <CourseCardWrapper onClick={clickOnCard} inGrid={inGrid} module={'dashboard'} draftCourses={draftCourses}>
      <CourseImageWrapper>
        {isUpdating && (
          <UpdatingSpinnerContainer>
            <LoadingSpinner />
          </UpdatingSpinnerContainer>
        )}
        {draftCourses && courseInfo.draft && <Ribbon word={t('globals.draft')} />}
        <Figure.Rectangle>
          {!imageUrl ? (
            <ImagePlaceholder $backgroundColor={themeGradientBg(themeColor)} ownerLogo={courseInfo.ownerLogo} />
          ) : (
            <img src={imageUrl} alt='CourseImage' loading='lazy' />
          )}
        </Figure.Rectangle>
      </CourseImageWrapper>
      <CourseInfoWrapper course={courseInfo} showProgress={!courseInfo.canEdit} showButtons ownerColor={courseInfo.ownerColor} ownerName={courseInfo.ownerName}>
        <Flex justify='space-between'>
          {courseInfo.canEdit ? (
            <SimpleButton startIcon='Edit' variant='secondary' fullWidth='true' onClick={clickForEditCourse}>
              {t('course.editCourse')}
            </SimpleButton>
          ) : (
            <SimpleButton startIcon='Student' variant='secondary' fullWidth='true'>
              {t('globals.continueCourse')}
            </SimpleButton>
          )}
        </Flex>
      </CourseInfoWrapper>
    </CourseCardWrapper>
  );
};

export default DashboardCourseCard;
